import { DownForMaintenanceView } from 'components/DownForMaintenanceView';
import { PageWrapper } from 'components/PageWrapper';
import React, { FC } from 'react';
import { selectPreferencesStatus } from '../../preferencesSelectors';
import {
  trackDisplayDownForMaintenanceMessage,
  trackDisplayEmptySubscriptionListMessage,
  trackDisplayUserNotFoundMessage,
} from '../../services/userActionEvents';
import { EmptyView } from './components/EmptyView';
import { LoginRedirect } from '../../../../components/LoginRedirect';
import { useAppSelector } from '../../../../hooks';
import { MyAtlassianRedirect } from '../../../../components/MyAtlassianRedirect';

const StatusView: FC = () => {
  const { status, message } = useAppSelector(selectPreferencesStatus);
  switch (status) {
    case 'login-required':
      return (
        <PageWrapper>
          <LoginRedirect />
        </PageWrapper>
      );
    case 'not-found':
      trackDisplayUserNotFoundMessage();
      return (
        <PageWrapper>
          <MyAtlassianRedirect />
        </PageWrapper>
      );
    case 'down-for-maintenance':
      trackDisplayDownForMaintenanceMessage();
      return (
        <PageWrapper>
          <DownForMaintenanceView message={message!} />
        </PageWrapper>
      );
    case 'empty':
      trackDisplayEmptySubscriptionListMessage();
      return (
        <PageWrapper>
          <EmptyView />
        </PageWrapper>
      );
    default:
      return null;
  }
};

export default StatusView;
